import React, {Component} from "react";
import BlockItem from "../blockitem/BlockItem";

class BlockSearch extends Component {
    constructor(props) {
        super(props);
        this.state = {
            height: 0
        }
    }

    updateScale(height) {
        this.setState((state) => {
            if (!!(height) && height > state.height) {
                return {height: height}
            }
        });
    }

    render() {
        return (
            <div id={"BLOCK_" + this.props.block.id} className="coreBlockForm"
                 style={Object.assign({}, {height: this.state.height + 'px'}, JSON.parse(!(this.props.block.style) ? "{}" : this.props.block.style))}>

                {this.props.block.blockItems.map(blockItem => (
                    <BlockItem
                        key={blockItem.id}
                        blockItem={blockItem}
                        onChange={this.props.onChange}
                        updateScale={this.updateScale.bind(this)}
                        externalCall={this.props.externalCall}/>
                ))}
            </div>
        )
    }
}

export default BlockSearch;